import React, { useEffect } from 'react';
import { useState } from 'react';
import { FaAddressCard } from "react-icons/fa";
import TextInput from '../ui/TextInput';
import Districts from './GeoCodeData/Districts';
import Divisions from './GeoCodeData/Divisions';
import Upazilas from './GeoCodeData/Upazilas';
// import Unions from './GeoCodeData/Unions';
import { useDispatch, useSelector } from 'react-redux';
import { setFromInfo } from '../../features/checkout/checkoutSlice';

const Invoice = () => {
    const { invoice, } = useSelector((state) => state.checkout);
    const { userInfo } = useSelector((state) => state.user);

    const dispatch = useDispatch();
    const [showDifrentAddressFilds, setShowDifrentAddressFilds] = useState(false);

    const [division, setDivision] = useState('');
    const [district, setDistrict] = useState('');
    const [upazila, setUpazila] = useState('');
    // const [unions, setUnions] = useState('');

    const DistrictsBydivision = Districts.filter((di) => di.division_id === division.split(' ')[0]);
    const UpazilasByDistrict = Upazilas.filter((di) => di.district_id === district.split(' ')[0]);
    // const UnionsByUpazila = Unions.filter((di) => di.upazilla_id === upazila.split(' ')[0]);

    const setDataToState = (name, data) => {
        dispatch(setFromInfo({ 'name': name, 'data': data }))
    };

    const setFildsData = (unionE) => {
        const fildsData = [division, district, upazila, unionE];
        dispatch(setFromInfo({ name: 'addressFillds', 'data': fildsData }))
    };

    useEffect(() => {
        if (userInfo) {
            dispatch(setFromInfo({ 'name': 'inemail', 'data': userInfo?.email }));
        }
        // if (invoice) {
        //     dispatch(setFromInfo({ 'name': 'inmobile', 'data': invoice?.mobile }));
        // }
        if (userInfo) {
            dispatch(setFromInfo({ 'name': 'inname', 'data': userInfo?.displayName }));
        }
    }, [userInfo]);



    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    return (
        <div>
            <div className="title-div flex content-center gap-1">
                <div className="grid content-center">
                    <FaAddressCard className='text-xl text-bnd-1' />
                </div>
                <h3 className='text-lg font-medium text-gray-500 font-poppins'>{translate ? "Invoice Details" : "চালান বিস্তারিত"}</h3>
            </div>
            <div>

                <div className='mt-3'>
                    <TextInput defaultValue={userInfo?.displayName} onBlur={(e) => setDataToState('inname', e.target.value)} autoComplete="false" title={translate ? "Name *" : "নাম *"} />
                </div>
                <div className='mt-3'>
                    <TextInput defaultValue={invoice?.mobile} onBlur={(e) => setDataToState('inmobile', e.target.value)} autoComplete="false" title={translate ? "Mobile *" : "মোবাইল নাম্বার *"} />
                </div>
                <div className='mt-3'>
                    <TextInput defaultValue={userInfo?.email} type="email" required onBlur={(e) => setDataToState('inemail', e.target.value)} autoComplete="false" title={translate ? "Email *" : "ইমেইল*"} />
                </div>
                <div className='mt-3'>
                    <label className="block text-md font-normal text-gray-600 mb-0">
                        {translate ? "Province *" : "প্রদেশ *"}
                    </label>
                    <select onChange={(e) => setDivision(e.target.value)} id="countries" className="w-full border border-gray-800 rounded h-9  focus:outline-offset-2  outline-blue-500/50 px-2 py-1 text-gray-600">
                        <option defaultValue="" selected>{translate ? "select your division province *" : "আপনার প্রদেশ নির্বাচন করুন *"}</option>
                        {Divisions?.length > 0 && Divisions.map((div, i) => (
                            <option
                                value={div.id + ' ' + div.name}
                                key={i}
                            >
                                {div.name}
                            </option>
                        ))}
                    </select>
                </div>
                {DistrictsBydivision?.length > 0 && <div className='mt-3'>
                    <label className="block text-md font-normal text-gray-600 mb-0">
                        {translate ? "City *" : "ঠিকানা*"}
                    </label>
                    <select onChange={(e) => setDistrict(e.target.value)} id="countries" className="w-full border border-gray-800 rounded h-9  focus:outline-offset-2  outline-blue-500/50 px-2 py-1 text-gray-600">
                        <option defaultValue="" selected>{translate ? "select your city" : "আপনার ঠিকানা নির্বাচন করুন"}</option>
                        {DistrictsBydivision && DistrictsBydivision.map((div, i) => (
                            <option
                                value={div.id + ' ' + div.name}
                                key={i}
                            >
                                {div.name}
                            </option>
                        ))}
                    </select>
                </div>}
                {UpazilasByDistrict?.length > 0 && <div className='mt-3'>
                    <label className="block text-md font-normal text-gray-600 mb-0">
                        {translate ? "Area *" : "এলাকা *"}
                    </label>
                    <select onChange={(e) => { setUpazila(e.target.value); setFildsData(e.target.value) }} id="countries" className="w-full border border-gray-800 rounded h-9  focus:outline-offset-2  outline-blue-500/50 px-2 py-1 text-gray-600">
                        <option defaultValue="" selected>{translate ? "select your area" : "আপনার এলাকা নির্বাচন করুন"}</option>
                        {UpazilasByDistrict && UpazilasByDistrict.map((div, i) => (
                            <option
                                value={div.id + ' ' + div.name}
                                key={i}
                            >
                                {div.name}
                            </option>
                        ))}
                    </select>
                </div>}
                {/* {UnionsByUpazila?.length > 0 && <div className='mt-3'>
                    <label className="block text-md font-normal text-gray-600 mb-0">
                        Unions *
                    </label>
                    <select onChange={(e) => { setUnions(e.target.value); setFildsData(e.target.value) }} id="countries" className="w-full border border-gray-800 rounded h-9  focus:outline-offset-2  outline-blue-500/50 px-2 py-1 text-gray-600">
                        <option defaultValue="" selected>select your unions</option>
                        {UnionsByUpazila && UnionsByUpazila.map((div, i) => (
                            <option
                                value={div.id + ' ' + div.name}
                                key={i}
                            >
                                {div.name}
                            </option>
                        ))}
                    </select>
                </div>} */}
                <div className='mt-3'>
                    <TextInput defaultValue={invoice?.address} onBlur={(e) => setDataToState('inaddress', e.target.value)} title={translate ? "Address *" : "ঠিকানা *"} />
                </div>
                <div onClick={() => setShowDifrentAddressFilds(!showDifrentAddressFilds)} className="flex items-center mt-2">
                    <input id="default-checkbox" type="checkbox" value={showDifrentAddressFilds} className="w-3 h-3 text-blue-600 bg-gray-100 rounded border-gray-300" />
                    <label htmlFor="default-checkbox" className="ml-2 text-md mb-0 font-normal text-gray-600">{translate ? "Deliver To A Different Address?" : "একটি ভিন্ন ঠিকানায় পণ্য পাঠান?"} </label>
                </div>
            </div>

            <div className={`${showDifrentAddressFilds ? 'block ease-in duration-300' : 'hidden ease-in duration-300'}`}>
                <div className='mt-3'>
                    <TextInput onBlur={(e) => setDataToState('ddfName', e.target.value)} title={translate ? "Name" : "নাম"} />
                </div>
                <div className='mt-3'>
                    <TextInput onBlur={(e) => setDataToState('ddfMobile', e.target.value)} title={translate ? "Mobile" : "মোবাইল নাম্বার"} />
                </div>
                <div className='mt-3'>
                    <TextInput onBlur={(e) => setDataToState('ddfEmail', e.target.value)} title={translate ? "Email" : "ইমেইল ঠিকানা"} />
                </div>
                <div className='mt-3'>
                    <TextInput onBlur={(e) => setDataToState('ddfArea', e.target.value)} title={translate ? "Area" : "এলাকা"} />
                </div>
                <div className='mt-3'>
                    <TextInput onBlur={(e) => setDataToState('ddfaddress', e.target.value)} title={translate ? "Address" : "ঠিকানা"} />
                </div>
            </div>
        </div>
    );
};

export default Invoice;